import { createFileRoute } from '@tanstack/react-router'

import { WorkflowAnalyticsDashboard } from '@/components/pm/analytics/workflow-analytics-dashboard'

export const Route = createFileRoute('/_authenticated/pm/workflow-analytics')({
  component: WorkflowAnalyticsPage,
})

function WorkflowAnalyticsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">工作流分析</h1>
        <p className="text-muted-foreground">查看工作流各阶段的统计数据和效率分析</p>
      </div>

      <WorkflowAnalyticsDashboard />
    </div>
  )
}
